import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/cafés.svg";
import Fashion from "@/assets/fashion.svg";
import ATM from "@/assets/atm.svg";
import CustomerServiceDesk from "@/assets/info.svg";
import Desserts from "@/assets/confectionary.svg";
import Entrance from "@/assets/entrance.svg";
import FastFood from "@/assets/fast_food.svg";
import GiftCard from "@/assets/gift_cards.svg";
import HomeTech from "@/assets/home&tech.svg";
import Hypermarket from "@/assets/hypermarkets.svg";
import JewelleryWatches from "@/assets/jewellery_&_watches.svg";
import LostFound from "@/assets/box.svg";
// import LuggageBagDrop from '@/assets/luggage_bag_drop.svg';
import MallManager from "@/assets/manager.svg";
import PrayerRoomMale from "@/assets/prayer_room_female.svg";
import PrayerRoomFemale from "@/assets/prayer_room_male.svg";
import RedCrescent from "@/assets/charity.svg";
import RestroomFemale from "@/assets/female.svg";
import RestroomMale from "@/assets/men.svg";
import Taxi from "@/assets/taxi.svg";
import UberCareem from "@/assets/uber.svg";
import ValetParking from "@/assets/valet.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/coin.svg";
import Wheelchair from "@/assets/wheelchair.svg";
import BabyChangingFemale from "@/assets/changing.svg";
import BabyChangingMale from "@/assets/changing-1.svg";
import FirstAid from "@/assets/first_aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import FamilyParking from "@/assets/family-parking.svg";
import Hotel from "@/assets/hotel-solid.svg";
import HotelWhite from "@/assets/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

import Banks from "@/assets/project-assets/banks.svg";
import Books from "@/assets/project-assets/books.svg";
import Electronics from "@/assets/project-assets/electronics.svg";
import FashionAccessories from "@/assets/project-assets/fashions-accessoiries.svg";
import FashionLadies from "@/assets/project-assets/fashionlandies.svg";
import FashionMen from "@/assets/project-assets/fashionmen.svg";
import FashionUnisex from "@/assets/project-assets/fashionunisex.svg";
import Swimwear from "@/assets/project-assets/swimwear.svg";
import Optics from "@/assets/project-assets/optics.svg";
import Pharmacies from "@/assets/project-assets/phamacies.svg";
import Speciality from "@/assets/project-assets/servicesandspecialitystores.svg";
import SportsWear from "@/assets/project-assets/sportswear.svg";
import ForkKnife from "@/assets/project-assets/fork-knife.svg";
import ExpectantParking from "@/assets/project-assets/Expectant-mother-parking.svg";
import ElectricCarCharging from "@/assets/project-assets/Electric-car-charging.svg";
import BabyFeeding from "@/assets/baby-feeding.svg";
import Bus from "@/assets/project-assets/bus.svg";
import ElectricScooter from "@/assets/project-assets/electric-scooter-station.svg";
import BikeParking from "@/assets/project-assets/bike-parking.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "185.6,100%,41.8%",
    icon: FaBagShopping,
    items: [
      {
        title: "banks-financial",
        iconImage: Banks,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:82d07cba-ab53-4e86-a061-b5ebf36c1e0a",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "books-stationery-toys-games-gifts",
        iconImage: Books,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:268e5a0b-d4da-4c6a-9880-13e9db3832a5",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "electronics-home-mobile",
        iconImage: Electronics,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:c4232dbe-84bd-4659-9d96-4aa3355c7201",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-accessories",
        iconImage: FashionAccessories,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:62faf3b4-75c3-466f-8cf9-b0928303c80c",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-child",
        iconImage: Fashion,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:4ec98d1f-84c8-4057-8ad7-314f38701b86",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-ladies",
        iconImage: FashionLadies,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:bd210b15-9b3e-4463-8fc6-c71c3f0a552d",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-men",
        iconImage: FashionMen,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:4d0eabb3-2624-4025-8865-867839e4592a",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-unisex",
        iconImage: FashionUnisex,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:7744869b-0c62-4d39-9c07-5566c3494c79",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "household-furtniture-carpet",
        iconImage: HomeTech,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:962e7046-0fc3-42e6-8088-2d4ae5f608de",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:a4575db3-7844-4782-9f31-4338f4290e44",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:517ca3a0-f4b9-47d2-8613-6e2f3da446c5",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "lingerie-swimwear",
        iconImage: Swimwear,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:46e36fbd-04c4-4b5e-8c05-9902aa4631f8",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-sunglasses",
        iconImage: Optics,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:17fd7036-2bc2-4ef8-9990-579521038c26",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "pharmacy-health-fitness-cosmetics-perfumes",
        iconImage: Pharmacies,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:64d7e00b-b89d-4d3b-ad7a-9f5200954cba",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "speciality-stores",
        iconImage: Speciality,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:835ca8b5-2f6f-4eee-8977-3c8dfc738700",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sportswear-goods",
        iconImage: SportsWear,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:53e65108-0174-4b9c-b5f1-776d96c9d051",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "10.6,100%,61.2%",
    icon: FaUtensils,
    items: [
      {
        title: "cafes",
        iconImage: Cafe,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:324cb7ce-1007-4210-9c6a-26cbcec3ecaa",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "chocolates-confectionery-icecream",
        iconImage: Desserts,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:b4a9a0a1-b0ff-4618-83bb-156fb31bd4ee",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:2f66660c-e41f-4e5d-9f1e-28e0b75ede43",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: ForkKnife,
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:c516e03d-308d-4bb0-a6b0-536bf2ee489d",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "entertainment",
    id: "entertainment",
    color: "284.4,100%,38.4%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "hotels",
    id: "hotels",
    color: "208,100%,33%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    listed: false,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "be10bdce-cd82-4c67-8559-2e6b8e78d587:5ce8d16a-e795-4e2c-802c-083312db4d06",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "40.6,99%,61.4%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:19603d36-fae8-4d37-b813-8e86d8877f2a",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:06d7075f-d935-4c46-937b-55b033e01903",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:8ffeccfb-09aa-42d4-8c15-36d92665d562",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:6d3258c9-4926-4597-b052-186a9834fa4c",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:16f64fd2-de93-40d7-b8c9-c1e19e66bc39",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:092fffc4-2435-44f4-a9d1-ad80d8f458ff",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-care-room",
        iconImage: BabyFeeding,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:5b64b498-9cea-4eab-82aa-1831f53afd66",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:8ffeccfb-09aa-42d4-8c15-36d92665d562",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:6d3258c9-4926-4597-b052-186a9834fa4c",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:8ffeccfb-09aa-42d4-8c15-36d92665d562",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:6d3258c9-4926-4597-b052-186a9834fa4c",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "taxi-pickup",
        iconImage: Taxi,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:c5e41957-a11d-4321-95ee-dc8bcd6cf4ec",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "uber-careem",
        iconImage: UberCareem,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:38792377-776d-4c52-a6ff-d546ab2a657e",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "bus-stop",
        iconImage: Bus,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:36648fcb-447d-40da-b612-c7286b81f8fb",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:af236499-6379-451b-a607-046eabc5ddac",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "valet-parking",
        iconImage: ValetParking,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:f462e18d-a037-4627-8f4d-3732ba567f51",
        type: "list",
        excludeFromSearch: false,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:3b7330f1-d1ed-479f-b04f-eb491209bbde",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "family-parking",
        iconImage: FamilyParking,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:6d0b22c0-dedf-4c3c-8fca-09999576dc03",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "expectant-mother-parking",
        iconImage: ExpectantParking,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:6d22202a-8797-485d-88c7-e8df081255b0",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "electric-car-charging",
        iconImage: ElectricCarCharging,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:b4706894-6ada-4e9c-b29a-c5eefff0ec6d",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "bike-parking",
        iconImage: BikeParking,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:47923a9c-9822-4f20-b415-7154c56bcfb4",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "electric-scooter-station",
        iconImage: ElectricScooter,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:dbb81e9e-0782-4bb3-94ae-4583dcb2bac2",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "charity",
        iconImage: RedCrescent,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:61cc98aa-4573-41ec-8086-b4e5ce326b60",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:ba66ce45-435d-48d5-b9a4-0d370bf7f260",
        type: "closest",
        hideMapIcon: false,
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      {
        title: "first-aid-room",
        iconImage: FirstAid,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:c77f49b5-6794-4814-a3dd-cc3fb317886a",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:367144c8-a89e-4f74-9f7d-3e912b521605",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:092fffc4-2435-44f4-a9d1-ad80d8f458ff",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "1953dcc6-480b-4766-9534-b6108dfc29c2:54ee6bb4-9ad4-49a0-8cc0-391bf8360aaa",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking-bays",
        id: [],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "vacant",
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:55600c00-7383-4e4e-8119-a08b0ac5801f",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "others",
        id: [
          "1953dcc6-480b-4766-9534-b6108dfc29c2:7bc360c0-96a4-42b8-9492-67843dcf21d4",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "parking",
        id: [],
        type: "list",
        listed: true,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "notlistedbuttobehide",
        id: [],
        type: "list",
        listed: false,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At City Centre Mirdif</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in City Centre Mirdif and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في سيتي سنتر مردف</h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
